export enum Types {
  GET_USER_TRUSTED_DEVICES_REQUEST = 'GET_USER_TRUSTED_DEVICES_REQUEST',
  GET_USER_TRUSTED_DEVICES_FULFILLED = 'GET_USER_TRUSTED_DEVICES_FULFILLED',
  GET_USER_TRUSTED_DEVICES_REJECTED = 'GET_USER_TRUSTED_DEVICES_REJECTED',
  DELETE_TRUSTED_DEVICE_REQUEST = 'DELETE_TRUSTED_DEVICE_REQUEST',
  DELETE_TRUSTED_DEVICE_FULFILLED = 'DELETE_TRUSTED_DEVICE_FULFILLED',
  DELETE_TRUSTED_DEVICE_REJECTED = 'DELETE_TRUSTED_DEVICE_REJECTED',
}
